module.exports = __webpack_public_path__ + "img/sl.68c0bef0.svg";